/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerabout1Inputs */

const en_organizerabout1 = /** @type {(inputs: Organizerabout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const de_organizerabout1 = /** @type {(inputs: Organizerabout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über dich`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Organizerabout1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerabout1 = /** @type {((inputs?: Organizerabout1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerabout1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerabout1(inputs)
	return de_organizerabout1(inputs)
});
export { organizerabout1 as "organizerAbout" }